export enum PropType {
  Default,
  Situation,
  Environment,
}

export const getEnvironmentPropPositionId = (environmentMetadataId: string) =>
  `environment-prop:${environmentMetadataId}`;

export interface Prop {
  id: string; // this is the instance id
  propId: string; // id of the prop (backend)
  name: string; // visual name
  prefabName: string;
  propType: PropType;
  hideInPropLibrary?: boolean;
  link?: { parentId: string; positionId: string }; // the situation this prop is linked to + on which position the prop is located
  environmentMetadataId?: string; // Environment Prop marker this preset was promoted from
}
